import { Component, OnInit } from '@angular/core';
import {faFacebookF , faTwitter, faLinkedinIn, faYoutube, faInstagram} from '@fortawesome/fontawesome-free-brands'
import {gutil} from '../../gutil';
import {Router } from "@angular/router";

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss']
})
export class AppFooterComponent implements OnInit {

  public faFB = faFacebookF;
  public faTwitter = faTwitter
  public faInsta = faInstagram;
  public faLinkedin = faLinkedinIn;
  public faYT = faYoutube;
  public city:any;
  public locality:any;

  constructor(private router: Router ) { }

  ngOnInit() {
    window.scroll(0,0);
  }

  public socialLinks(url: string){
        window.open(url , '_blank');
  }
  public propSingleSearch(city:string, locality:string, type:number) {
    var loc :string = "Co-Living";
    if(type == 0){
      gutil.searchData.sharetype = 1;
    }else{
      gutil.searchData.sharetype = type;
    }
    gutil.searchData.city = city;
    this.router.navigate(['/'+gutil.searchData.city+'/properties-for-rent/'+locality + '/' + loc]).then(() => {
      window.location.reload();
    });
  }
  ////Fam search here/////
  public propFamSearch(city:string, locality:string, type:number) {
    var loc:string = "Family";
    gutil.searchData.city = city;
    this.router.navigate(['/'+gutil.searchData.city+'/properties-for-rent/'+locality + '/' + loc]).then(() => {
      window.location.reload()
    });
  }
  public propCitySingleSearch(city:string) {
    gutil.searchData.sharetype = 1;
    gutil.searchData.city = city;
    this.router.navigate(['/'+gutil.searchData.city+'/rooms-for-rent/' + 'Co-Living']).then(() => {
      window.location.reload();
    });
  }
  public propCityFamSearch(city:string) {
    var loc:string;
    if(city == 'bengaluru') {
      loc = 'Bellandur';
    }
    else {
      loc = 'Kharadi';
    }
    gutil.searchData.sharetype = 3;
    gutil.searchData.gender = 0;
    gutil.searchData.city = city;
    this.router.navigate(['/'+gutil.searchData.city+'/properties-for-rent/' + loc + '/' + 'Family']).then(() => { 
      window.location.reload();
    });
  }
  public propPremiumSearch(city:string, locality:string) {
    gutil.searchData.city = city;
    this.router.navigate(['/' + gutil.searchData.city + '/premium-properties-for-rent/' + locality]).then(() => {
      window.location.reload();
    })
  }
  public propPremCitySearch(city:string) {
    var loc:string;
    if(city == 'bengaluru') {
      loc = "Bellandur";
    }
    else {
      loc = "Kharadi";
    }
    gutil.searchData.city = city;
    this.router.navigate(['/' + gutil.searchData.city + '/premium-properties-for-rent/' + loc]).then(() => {
      window.location.reload();
    })
  }
}